<template>
    <label :class="formType === 'costsIndicator' ? 'sw-index' : 'sw-label'">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot></slot></span>
    </label>
</template>

<script>
    export default {
        props: {
            value: [String, Number],
            formType: {
                type: String,
                default: 'contact',
            }
        }
    }
</script>
<style scoped lang="sass">

.sw-label
    color: black
    font-weight: 500
    display: block
    font-size: 1rem
    margin-bottom: 5px

</style>

